import React from 'react';
import { useController, ApplicationView as view } from '@aha-app/mvc';
import { SelectroController } from '@aha-app/selectro-v2';

// Basic assign to me action that can be attached to assigned to fields.
// This component expects to have the currentUser in the users selectro presenter format in
// state.custom.currentUser, to set the value use the custom prop.
const UserAssignToMeAction: React.FC = () => {
  const controller = useController(SelectroController);
  const { state } = controller;

  const isCurrentUserSelected = controller.selected.some(
    selectedItem =>
      state.custom.currentUser &&
      selectedItem.value === state.custom.currentUser.value
  );

  // If there is no current user, we don't want to render the action.
  if (!state.custom.currentUser || isCurrentUserSelected) return null;

  const handleClick = (e: React.MouseEvent<HTMLDivElement>) => {
    // We don't want to open the dropdown when clicking this action.
    e.preventDefault();
    e.stopPropagation();
    // We want to add the current user to the selected items.
    controller.actionSetSelected(
      // * If single select, we replace the selected item.
      controller.isSingleSelect
        ? state.custom.currentUser
        : controller.selected.concat(state.custom.currentUser)
    );
  };

  return (
    <div onClick={handleClick}>
      <aha-button kind='link'>Assign to me</aha-button>
    </div>
  );
};

export default view(UserAssignToMeAction);
